import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import * as React from 'react';

export const TrashIcon = ({ color = '' }) => {
  const styleObj: React.CSSProperties = !!color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faTrash} size="sm" />;
};
